import Vue from 'vue'

const SET_EMPRESA_ATIVO = (state,intEmpresaAtivo) => {
	state.intEmpresaAtivo = intEmpresaAtivo
}

export{
	SET_EMPRESA_ATIVO
}
